<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough" transform="matrix(-1,0,0,1,28,0)">
        <path
          d="M14.712915,3.9578266666793827C14.183923,3.799126666679382,13.883739,3.241646666679382,14.042437,2.712651666679382C14.201135,2.1836596666793824,14.758618,1.8834756666793824,15.28761,2.0421736666793824C15.28761,2.0421736666793824,25.287599999999998,5.042176666679382,25.287599999999998,5.042176666679382C26.2378,5.327236666679383,26.2378,6.672766666679382,25.287599999999998,6.957826666679383C25.287599999999998,6.957826666679383,15.28761,9.957826666679383,15.28761,9.957826666679383C14.758618,10.116526666679382,14.201135,9.816336666679383,14.042437,9.287346666679383C13.883739,8.758356666679383,14.183923,8.200876666679381,14.712915,8.042176666679381C14.712915,8.042176666679381,21.52016,5.999996666679382,21.52016,5.999996666679382C21.52016,5.999996666679382,14.712915,3.9578266666793827,14.712915,3.9578266666793827C14.712915,3.9578266666793827,14.712915,3.9578266666793827,14.712915,3.9578266666793827ZM15.00026,12.000036666679382C15.00026,12.000036666679382,25.0003,12.000036666679382,25.0003,12.000036666679382C25.552500000000002,12.000036666679382,26.0003,12.447736666679383,26.0003,13.000036666679382C26.0003,13.552236666679383,25.552500000000002,14.000036666679382,25.0003,14.000036666679382C25.0003,14.000036666679382,15.00026,14.000036666679382,15.00026,14.000036666679382C14.447977999999999,14.000036666679382,14.000263304,13.552236666679383,14.000263304,13.000036666679382C14.000263304,12.447736666679383,14.447977999999999,12.000036666679382,15.00026,12.000036666679382C15.00026,12.000036666679382,15.00026,12.000036666679382,15.00026,12.000036666679382Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LessThanOrEqualTo',
} as DefineComponent
</script>
